import { memo, useContext, useEffect } from "react";

//scss
import "./style.scss";

//assets
import { SvgGuest } from "assets/icons/js/SvgGuest";

//components
import GuestPopUp from "components/Home/SearchBar/GuestPopUp";
import SaveClear from "../SaveClear";
import { ListingInterface } from "context/ListingData";
import { SvgNavigationArrow } from "assets/icons/js/SvgNavigationArrow";
import { useTheme } from "components/ListingNew/ListingTheme";

const BookingGuestSelect = memo(({ setContent, onClose, listingList }) => {
	const {
		setChildrenData,
		setAdultsData,
		setRoomsData,
		setInfantsData,
		roomsData,
		childrenData,
		adultsData,
		guestsData,
		infantsData,

		showPet,
		setPetData,
		petData,
		petCharge,
	} = useContext(ListingInterface);

	const onSave = () => {
		setContent("dates");
	};

	const onClear = () => {
		setChildrenData(0);
		if (listingList?.TYPE_FLAG === "EV" || listingList?.TYPE_FLAG === "EV-MR") {
			setAdultsData(listingList?.MIN_ROOMS * listingList?.CAPACITY);
		} else {
			setAdultsData(listingList?.CAPACITY * roomsData);
		}
		if (listingList?.MIN_ROOMS) {
			setRoomsData(listingList?.MIN_ROOMS);
		}
		setInfantsData(0);
	};

	const theme = useTheme();

	return (
		<div className="booking-guest-select">
			<div className="booking-date-top">
				<SvgNavigationArrow onClick={onClose} />
				<h3 style={{ color: theme.primaryTextColor }}>Add Guests & Rooms</h3>
			</div>
			<div className="guest_select-pos">
				<div className="booking-guest-select__guest-box text-sm clr-black">
					<SvgGuest />
					{adultsData + childrenData} Guests{" "}
					{listingList?.TYPE_FLAG === "MV"
						? "- " + roomsData
						: listingList?.TYPE_FLAG === "EV"
						? ""
						: "- " + roomsData}
					{listingList?.TYPE_FLAG === "MV"
						? " Villa"
						: listingList?.TYPE_FLAG === "EV"
						? ""
						: " Rooms"}
				</div>
				<GuestPopUp
					theme={theme}
					data={guestsData}
					open={true}
					typeData={listingList}
					infantsData={infantsData}
					childrenData={childrenData}
					adultsData={adultsData}
					roomsData={roomsData}
					setAdultsData={setAdultsData}
					setChildrenData={setChildrenData}
					setInfantsData={setInfantsData}
					setRoomsData={setRoomsData}
					showPet={showPet}
					setPetData={setPetData}
					petData={petData}
					petCharge={petCharge}
				/>
			</div>
			<SaveClear onSave={onSave} onClear={onClear} />
		</div>
	);
});

export default BookingGuestSelect;
